(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            colorPicker()
            wishlist()
            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

 function colorPicker() {
  const OPEN_CLASS = 'is-open';

  function openDrawer(drawer, overlay) {
    drawer.classList.add(OPEN_CLASS);
    overlay.classList.add(OPEN_CLASS);

    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');

    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer(drawer, overlay) {
    drawer.classList.remove(OPEN_CLASS);
    overlay.classList.remove(OPEN_CLASS);

    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');

    document.documentElement.style.overflow = '';
  }

  function initDrawers() {
    document.querySelectorAll('.card__colorpicker').forEach(d => {
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-hidden', 'true');
      d.setAttribute('aria-modal', 'true');
    });

    document.querySelectorAll('.colorpicker-overlay').forEach(ov => {
      ov.setAttribute('aria-hidden', 'true');
    });
  }

  // === EVENTS =======================================================

  document.addEventListener('click', function (e) {

    // 1. Trigger ouvre/ferme drawer
    const trigger = e.target.closest('.card__colorpicker__trigger');
    if (trigger) {
      const id = trigger.dataset.id;
      if (!id) return;

      const drawer = document.getElementById(id);
      if (!drawer) return;

      const overlay = drawer.previousElementSibling;
      if (!overlay || !overlay.classList.contains('colorpicker-overlay')) return;

      // toggle
      if (drawer.classList.contains(OPEN_CLASS)) {
        closeDrawer(drawer, overlay);
      } else {
        document.querySelectorAll('.card__colorpicker.is-open').forEach(d => {
          const ov = d.previousElementSibling;
          if (ov && ov.classList.contains('colorpicker-overlay')) closeDrawer(d, ov);
        });
        openDrawer(drawer, overlay);
      }

      e.preventDefault();
      return;
    }

    // 2. clic overlay = fermer
    const overlay = e.target.closest('.colorpicker-overlay');
    if (overlay && overlay.classList.contains(OPEN_CLASS)) {
      const drawer = overlay.nextElementSibling;
      if (drawer && drawer.classList.contains('card__colorpicker')) closeDrawer(drawer, overlay);
    }

    // 3. bouton interne qui ferme
    const closingTrigger = e.target.closest('.colorpicker-closing-trigger');
    if (closingTrigger) {
      const drawer = closingTrigger.closest('.card__colorpicker');
      if (!drawer) return;
      const overlay = drawer.previousElementSibling;
      if (overlay && overlay.classList.contains('colorpicker-overlay')) closeDrawer(drawer, overlay);
    }
  });

  // Escape pour fermer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const drawer = document.querySelector('.card__colorpicker.is-open');
      if (!drawer) return;
      const overlay = drawer.previousElementSibling;
      if (overlay) closeDrawer(drawer, overlay);
    }
  });

  // Init
  initDrawers();

  // Ré-Init Shopify
  document.addEventListener('shopify:section:load', initDrawers);
  document.addEventListener('shopify:section:reorder', initDrawers);
}


  function wishlist() {
    const wishlistButtons = document.querySelectorAll('.wishlist_fav');

              // Boucle sur chacun et ajoute un écouteur de clic
              wishlistButtons.forEach((btn) => {
                btn.addEventListener('click', async (event) => {
                  const element = event.currentTarget;
                
                  // 🔒 Anti-spam : si déjà en cours, on sort
                  if (element.dataset.disabled === "true") return;
                
                  // On bloque les clics et donne un petit feedback visuel
                  element.dataset.disabled = "true";
                  element.style.pointerEvents = "none"; // empêche de recliquer
                  element.style.opacity = "0.6"; // effet visuel optionnel

                  const body = {
                    productId: element.dataset.productId,
                    websiteCode: document.querySelector('#websiteCode').dataset.id,
                    action: element.dataset.action
                  };
                  const proxyPath = document.getElementById('proxyPathDiv')
                  const url = proxyPath.dataset.proxyPath + '/customer/wishlist'
                
                  try {
                    const r = await fetch(url, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(body)
                    });
                
                    const data = await r.json();
                
                    if (r.status === 200) {
                      const parent = element.parentElement; // ou .closest('[data-product-id]') si besoin
                      const other = parent.querySelector(
                        `.wishlist_fav[data-action="${element.dataset.action === 'add' ? 'remove' : 'add'}"]`
                      );
                
                      if (other) {
                        element.style.display = "none";
                        other.style.display = "block";
                      }
                    }
                
                  } catch (err) {
                    console.error(err);
                  } finally {
                    // 🔓 Réactive la div (pour éviter un blocage permanent)
                    element.dataset.disabled = "false";
                    element.style.pointerEvents = "auto";
                    element.style.opacity = "1";
                    if (window.location.pathname.endsWith('/pages/wishlist')) {
                      const gridItem = element.closest('.grid__item');
                      gridItem.remove()
                    }
                  }
                });
              });


              const clearWishlistButton = document.getElementById('clearWishlist')
              if(clearWishlistButton) {
                clearWishlistButton.addEventListener('click', async (event) => {
                  const body = {
                    websiteCode: document.querySelector('#websiteCode').dataset.id
                  };
                  
                  const proxyPath = document.getElementById('proxyPathDiv')
                  const url = proxyPath.dataset.proxyPath + '/customer/wishlist'
                  try {
                    const r = await fetch(url, {
                      method: 'DELETE',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(body)
                    });
                
                    const data = await r.json();
                
                    if (r.status === 200) {
                      window.location.reload()
                    }
                
                  } catch (err) {
                    console.error(err);
                  }
                })  
              }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-product-recommandations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
